import { useEffect, useRef, useState } from 'react';
import PDFViewer from '../view/PDFViewer';
import { Divider } from 'antd'
import { Outlet, useNavigate, useParams, useSearchParams } from "react-router-dom";
import Deck from '../3js/projects/Card';
import Project from '../3js/projects/Project';
export default function ProjectPage() {
    const [search, setSearch] = useSearchParams();
    const [url, setUrl] = useState()
    useEffect(() => {
        let id = search.get("id")
        setUrl(atob(id))
    }, []);

    return (
        <div style={{ height: 'calc(100vh - 67px)' }} className='bql-project-page' >
            <Project />
        </div>

    );
};